import { BrowserRouter, Route, Routes, useNavigate } from "react-router-dom";
import "./App.scss";
import Home from "./pages/Home";
import MobileOTP from "./pages/MobileOTP";
import Dashboard from "./pages/Dashboard";
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import Designation from "./pages/Designation";
import AddDesignation from "./pages/AddDesignation";
import EditDesignation from "./pages/EditDesignation";
import MyProfile from "./pages/MyProfile";
import Holiday from "./pages/Holiday";
import AddHoliday from "./pages/AddHoliday";
import EditHoliday from "./pages/EditHoliday";
import Notification from "./pages/Notification";
import AddNotification from "./pages/AddNotification";
import EditNotification from "./pages/EditNotification";
import Award from "./pages/Award";
import AddAward from "./pages/AddAward";
import EditAward from "./pages/EditAward";
import Page404 from "./pages/Page404";
import TeamLeader from "./pages/TeamLeader";
import AddTeamLeader from "./pages/AddTeamLeader";
import EditTeamLeader from "./pages/EditTeamLeader";
import 'react-loading-skeleton/dist/skeleton.css';
import 'bootstrap-css-only/css/bootstrap.min.css';
import 'mdbreact/dist/css/mdb.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import AllTicket from "./pages/ticket/AllTicket";
import TicketDetails from "./pages/ticket/TicketDetails";
import Employee from "./pages/employee/Employee";
import AddEmployee from "./pages/employee/AddEmployee";
import EmployeeDetails from "./pages/employee/EmployeeDetails";
import { useEffect, useRef } from "react";
import CenterPerformance from "./pages/report/CenterPerformance";
import CenterHeadPerformance from "./pages/report/CenterHeadPerformance";
import ClusterHead from "./pages/center/ClusterHead";
import CenterHead from "./pages/center/CenterHead";
import AgentList from "./pages/center/AgentList";


function AppWithInactivity() {
  const navigate = useNavigate();
  const timeoutRef = useRef(null);
  const INACTIVITY_TIMEOUT = 45 * 60 * 1000; // 45 Minutes

  const handleLogout = () => {
    localStorage.clear();
    toast.warning("You have been logged out due to inactivity.");
    navigate("/");
  };

  const startInactivityTimer = () => {
    timeoutRef.current = setTimeout(() => {
      handleLogout();
    }, INACTIVITY_TIMEOUT);
  };

  const resetInactivityTimer = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    startInactivityTimer();
  };

  useEffect(() => {
    // Disable Right Click (context menu)
    document.addEventListener("contextmenu", (e) => {
      e.preventDefault();
    });

    // Disable common keyboard shortcuts
    const disableShortcuts = (e) => {
      // Disable F12 (DevTools)
      if (e.key === "F12") {
        e.preventDefault();
      }

      // Disable Ctrl + Shift + I (Inspect Element)
      if (e.ctrlKey && e.shiftKey && e.key === "I") {
        e.preventDefault();
      }

      // Disable Ctrl + U (View Source)
      if (e.ctrlKey && e.key === "u") {
        e.preventDefault();
      }

      // Disable Ctrl + U (View Source)
      if (e.ctrlKey && e.key === "U") {
        e.preventDefault();
      }

      // Disable Ctrl + P (View Source)
      if (e.ctrlKey && e.key === "p") {
        e.preventDefault();
      }

      // Disable Ctrl + P (View Source)
      if (e.ctrlKey && e.key === "p") {
        e.preventDefault();
      }

      // Disable Ctrl + Shift + J (Console)
      if (e.ctrlKey && e.shiftKey && e.key === "J") {
        e.preventDefault();
      }

      // Disable Ctrl + Shift + J (Console)
      if (e.ctrlKey && e.shiftKey && e.key === "l") {
        e.preventDefault();
      }

      // Disable Ctrl + Shift + C (Element Inspector)
      if (e.ctrlKey && e.shiftKey && e.key === "C") {
        e.preventDefault();
      }
    };

    document.addEventListener("keydown", disableShortcuts);

    // Reset inactivity timer on user interaction
    document.addEventListener("mousemove", resetInactivityTimer);
    document.addEventListener("keydown", resetInactivityTimer);
    document.addEventListener("click", resetInactivityTimer);

    // Start the inactivity timer when the component mounts
    startInactivityTimer();

    return () => {
      // Cleanup event listeners on component unmount
      document.removeEventListener("mousemove", resetInactivityTimer);
      document.removeEventListener("keydown", resetInactivityTimer);
      document.removeEventListener("click", resetInactivityTimer);
      document.removeEventListener("contextmenu", (e) => e.preventDefault());
      document.removeEventListener("keydown", disableShortcuts);

      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/mobile-otp" element={<MobileOTP />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/employee" element={<Employee />} />
        <Route path="/add-employee" element={<AddEmployee />} />
        <Route path="/employee-details/:slug" element={<EmployeeDetails />} />
        <Route path="/designation" element={<Designation />} />
        <Route path="/add-designation" element={<AddDesignation />} />
        <Route path="/edit-designation/:slug" element={<EditDesignation />} />
        <Route path="/holiday" element={<Holiday />} />
        <Route path="/add-holiday" element={<AddHoliday />} />
        <Route path="/edit-holiday/:slug" element={<EditHoliday />} />
        <Route path="/notification" element={<Notification />} />
        <Route path="/add-notification" element={<AddNotification />} />
        <Route path="/edit-notification/:slug" element={<EditNotification />} />
        <Route path="/my-profile" element={<MyProfile />} />
        <Route path="/award" element={<Award />} />
        <Route path="/add-award" element={<AddAward />} />
        <Route path="/edit-award/:slug" element={<EditAward />} />
        <Route path="/team-leader" element={<TeamLeader />} />
        <Route path="/add-team-leader" element={<AddTeamLeader />} />
        <Route path="/edit-team-leader/:slug" element={<EditTeamLeader />} />
        <Route path="/all-tickets" element={<AllTicket />} />
        <Route path="/ticket-detail/:slug" element={<TicketDetails />} />
        <Route path="/center-performance" element={<CenterPerformance />} />
        <Route path="/center-head-performance/:slug" element={<CenterHeadPerformance />} />
        <Route path="/cluster-head-list" element={<ClusterHead />} />
        <Route path="/center-head-list/:slug" element={<CenterHead />} />
        <Route path="/agent-list/:slug" element={<AgentList />} />
        <Route path="*" element={<Page404 />} />
      </Routes>
      <ToastContainer position="bottom-center" />
    </>
  );
}


function App() {
  return (
    <BrowserRouter>
      <AppWithInactivity />
    </BrowserRouter>
  );
}

export default App;
